import http from '../services/httpClient';

/**
 * Continuous Closing Stock — a Locked month (spec §4.6, decision D5).
 *
 * For a switched-on business an entry dated in a month the owner has locked is refused
 * with code MONTH_LOCKED. Instead of a dead end, the person is offered the spec's way
 * through: post it as a prior-month adjustment — it is counted on the first open day,
 * labelled with its real date, and the locked month's figures do not move. (Reopening the
 * month is the owner's other option, on the Closing Stock screen.)
 *
 * @param {string} path      the POST endpoint
 * @param {object} body      the request body
 * @param {string} flagKey   the body field the endpoint reads for the choice
 * @param {object} [options] passed to http.post (e.g. an abort signal)
 */
export async function postWithLockedRetry(path, body, flagKey = 'priorMonthAdjustment', options) {
  try {
    return await http.post(path, body, options);
  } catch (error) {
    const data = error && error.data;
    if (data && data.code === 'MONTH_LOCKED' && !body[flagKey]) {
      const ok = window.confirm(
        `${data.error}\n\nPost it as a prior-month adjustment? It is counted on the first open day, `
        + 'labelled with its real date, and the locked month stays as it was signed off.'
      );
      if (ok) return http.post(path, { ...body, [flagKey]: true }, options);
    }
    throw error;
  }
}

export default postWithLockedRetry;
